export const MATRIX_COLS_DEFAULT = 3;
export const MATRIX_ROWS_DEFAULT = 100;
export const MATRIX_ITEM_ROWS_DEFAULT = 100;
export const MATRIX_SPACING_X_DEFAULT = 'space-700';
export const MATRIX_SPACING_Y_DEFAULT = 'space-0';
